import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

// The card every step renders inside, plus its footer navigation.
export const StepCard = ({ title, description, children }) => (
  <section className="step-card">
    <header className="step-card__head">
      <h1 className="step-card__title">{title}</h1>
      {description && <p className="step-card__desc">{description}</p>}
    </header>
    {children}
  </section>
);

StepCard.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  children: PropTypes.node.isRequired
};

export const StepActions = ({ onBack, backLabel = 'Back', children }) => (
  <div className="step-actions">
    {onBack ? (
      <button type="button" className="btn btn--ghost" onClick={onBack}>
        ← {backLabel}
      </button>
    ) : (
      <span />
    )}
    <div className="step-actions__right">{children}</div>
  </div>
);

StepActions.propTypes = {
  onBack: PropTypes.func,
  backLabel: PropTypes.string,
  children: PropTypes.node
};

export const Button = ({ variant = 'primary', loading, children, ...rest }) => (
  <button className={`btn btn--${variant}`} disabled={loading || rest.disabled} {...rest}>
    {loading && <span className="btn__spinner" aria-hidden="true" />}
    {children}
  </button>
);

Button.propTypes = {
  variant: PropTypes.oneOf(['primary', 'ghost', 'danger']),
  loading: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export const FieldGrid = ({ children }) => <div className="field-grid">{children}</div>;

FieldGrid.propTypes = { children: PropTypes.node.isRequired };

export const SectionRule = ({ label }) => (
  <div className="section-rule">
    <span className="section-rule__label">{label}</span>
    <span className="section-rule__line" />
  </div>
);

SectionRule.propTypes = { label: PropTypes.string.isRequired };
